module.exports = __webpack_public_path__ + "img/14.c424f153.jpg";